import { Box, Flex, Stack } from "@chakra-ui/react";
import FsLightbox from "fslightbox-react";
import { useState } from "react";
import { FiEye, FiPlus } from "react-icons/fi";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

function UpdatePostImageBackground({ children, ...props }) {
  // To open the lightbox change the value of the "toggler" prop.
	const [toggler, setToggler] = useState(false);
  const [open, setOpen] = useState(false);

  //console.log('toggler: ', toggler);
  const {profileInfo, selectedPhotoIndex} = props;

  const imageUrls = [];

  // Push image URLs into the array
  if (profileInfo?.photo1) imageUrls.push(profileInfo.photo1);
  if (profileInfo?.photo2) imageUrls.push(profileInfo.photo2);
  if (profileInfo?.photo3) imageUrls.push(profileInfo.photo3);
  if (profileInfo?.photo4) imageUrls.push(profileInfo.photo4);
  if (profileInfo?.photo5) imageUrls.push(profileInfo.photo5);
  if (profileInfo?.photo6) imageUrls.push(profileInfo.photo6);

  // Reorder the imageUrls based on the selectedPhotoIndex
  if (selectedPhotoIndex > 0 && selectedPhotoIndex <= imageUrls.length) {
    const selectedPhoto = imageUrls[selectedPhotoIndex - 1];
    imageUrls.splice(selectedPhotoIndex - 1, 1);
    imageUrls.unshift(selectedPhoto);
  }

  // Create an array of slide objects
  const slides = imageUrls.map((url) => ({ src: url }));

  return (
    <>
    {/* <FsLightbox
      toggler={toggler}
      sources={[
        `https://i.imgur.com/fsyrScY.jpg`,
        'https://www.youtube.com/watch?v=3nQNiWdeH2Q',
        'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4'
      ]}
      //sources={imageUrls}
    /> */}
    
      {/* <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={[
          { src: `${profileInfo?.photo1}` },
          { src: `${profileInfo?.photo2}` },
          { src: `${profileInfo?.photo3}` },
        ]}
      /> */}

      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={slides}
      />
   
    <Stack
      position={"relative"}
      w="70px"
      h="70px"
      justifyContent={"center"}
      alignItems="center"
    >
      {props?.isLoggedIn && !props?.id && (
        <Box
          className="profile-pic"
          bg="#00000024"
          w="70px"
          h="70px"
          maxW="70px"
          zIndex={"12"}
          position="absolute"
        />
      )}
      {children}
      {props?.isLoggedIn && !props?.id ? (
        <Stack style={{ zIndex: "13", position: "absolute" }}>
          <FiPlus
            cursor={"pointer"}
            onClick={() => props?.onClick()}
            fontSize={"2em"}
            color="#fff"
          />

          <FiEye
            cursor={"pointer"}
            onClick={() => setOpen(true)}
            fontSize={"2em"}
            color="#fff"
          />
        </Stack>
      ) : (
        <Stack style={{ zIndex: "13", position: "absolute" }}>
        <FiEye
          cursor={"pointer"}
          onClick={() => setOpen(true)}
          fontSize={"2em"}
          color="#fff"
        />
        </Stack>
      )}

    </Stack>
    </>
  );
}

export default UpdatePostImageBackground;
